import { DataBean } from "../DataBean";

export class TakingInventory extends DataBean {


    public async getPhysicalTakingInventoryCatalog(idPhysicalTaking:any,idProduct:any,regex:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPhysicalTakingInventoryCatalog_Number_Number_String_Number_Number_Number", [idPhysicalTaking,idProduct,regex,state,page,recordsPerPage]);
    }

//   public async getPhysicalTakingInventoryCatalog(idPhysicalTaking:any,idProduct:any,regex:any,state:any,page:any,recordsPerPage:any): Promise<any> {
//         return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPhysicalTakingInventoryCatalog_Number_Number_String_Number_Number_Number", [idPhysicalTaking,idProduct,regex,state,page,recordsPerPage]);
//     }
}